export const uk = {
	translation: {
		Бали: 'Бали',
		Замовлено: 'Замовлено',
		'Тип доставки': 'Тип доставки',
		Статус: 'Статус',
		Дії: 'Дії',
		'На цій сторінці можна побачити список товарів на вашому складі, доступних до оформлення на даний момент':
			'На цій сторінці можна побачити список товарів на вашому складі, доступних до оформлення на даний момент',
		'Час доставки': 'Час доставки',
		'Дата створення': 'Дата створення',
		'створити накладну': 'створити накладну',
		'створити оформлення': 'створити оформлення',
		'створити замовлення': 'створити замовлення',
		'товарний звіт': 'товарний звіт',
		'назва товару': 'назва товару',
		'у наявності': 'у наявності',
		'список оформлень': 'список оформлень',
		замовлено: 'замовлено',
		'кількість на складі': 'кількість на складі',
		балів: 'балів',
		назва: 'назва',
		бали: 'бали',
		кількість: 'кількість',
		сума: 'сума',
		оформлено: 'оформлено',
		вчора: 'вчора',
		сьогодні: 'сьогодні',
		всі: 'всі',
		Всі: 'Всі',
		чек: 'чек',
		"ім'я, контракт": "ім'я, контракт",
		оплата: 'оплата',
		чернетки: 'чернетки',
		дата: 'дата',
		'Внести готівку': 'Внести готівку',
		'Зняти готівку': 'Зняти готівку',
		'Закрити зміну': 'Закрити зміну',
		'Відкрити зміну': 'Відкрити зміну',
		'Вийти з касира': 'Вийти з касира',
		'список товарів': 'список товарів',
		'створити оплату': 'створити оплату',
		'Авторизувати касира': 'Авторизувати касира',
		'список накладних': 'список накладних',
		'Створення оформлення': 'Створення оформлення',
		'Дата проведення оформлення': 'Дата проведення оформлення',
		'Зареєструвати нового клієнта': 'Зареєструвати нового клієнта',
		'Показати все': 'Показати все',
		'В наявності': 'В наявності',
		Закінчилися: 'Закінчилися',
		'Обрані': 'Обрані',
		'Моя команда': 'Моя команда',
		дивитися: 'дивитися',
		більше: 'більше',
		менше: 'менше',
		'За товаром': 'За товаром',
		'За номером': 'За номером',
		'Введіть номер': 'Введіть номер',
		'Вибір місяця': 'Вибір місяця',
		Дні: 'Дні',
		Місяці: 'Місяці',
		'По клієнту': 'По клієнту',
		'Від дати': 'Від дати',
		'По дату': 'По дату',
		'Мають бути цифри': 'Мають бути цифри',
		'Історія змін для накладних відсутня': 'Історія змін для накладних відсутня',
		'Тут перелік ваших замовлень. За замовчуванням відображаються всі замовлення за останній місяць. Щоб побачити ті, які вам потрібно підтвердити (Надіслані) або ті, які ви вже підтвердили (Підтверджено) або інше, то ви можете натиснути кнопки нижче.':
			'Тут перелік ваших замовлень. За замовчуванням відображаються всі замовлення за останній місяць. Щоб побачити ті, які вам потрібно підтвердити (Надіслані) або ті, які ви вже підтвердили (Підтверджено) або інше, то ви можете натиснути кнопки нижче.',
		'Також нижче є можливість знайти замовлення за номером, за продуктом у накладній та за статусом.':
			'Також нижче є можливість знайти замовлення за номером, за продуктом у накладній та за статусом.',
		'Замовлення клієнтів': 'Замовлення клієнтів',
		Назад: 'Назад',
		'Обслуговувати якнайшвидше': 'Обслуговувати якнайшвидше',
		'пріоритет нижче, треба мати на увазі':
			'пріоритет нижче, треба мати на увазі',
		'цікавить в останню чергу': 'цікавить в останню чергу',
		"ім'я замовника": "ім'я замовника",
		вартість: 'вартість',
		'Статус доставки': 'Статус доставки',
		'Спосіб доставки': 'Спосіб доставки',
		'Спосіб оплати': 'Спосіб оплати',
		'Статус оплати': 'Статус оплати',
		'Всього грошей': 'Всього грошей',
		'Всього балів': 'Всього балів',
		Коментар: 'Коментар',
		Пошук: 'Пошук',
		Оплачено: 'Оплачено',
		Неоплачено: 'Неоплачено',
		Нове: 'Нове',
		Відхилено: 'Відхилено',
		Збирається: 'Збирається',
		Запаковано: 'Запаковано',
		Відправлено: 'Відправлено',
		Отримано: 'Отримано',
		Звичайне: 'Звичайне',
		Відкладене: 'Відкладене',
		'Нова пошта': 'Нова пошта',
		Самовивіз: 'Самовивіз',
		Картка: 'Картка',
		Готівка: 'Готівка',
		Доставлено: 'Доставлено',
		'Не доставлено': 'Не доставлено',
		'скасувати фільтр': 'скасувати фільтр',
		застосувати: 'застосувати',
		'Дата проведення': 'Дата проведення',
		'Редагування не доступне': 'Редагування не доступне',
		Видалити: 'Видалити',
		'Друк PDF': 'Друк PDF',
		'Друк Excel': 'Друк Excel',
		'Вид накладної': 'Вид накладної',
		'Замовник': 'Замовник',
		'Склад обслуговування': 'Склад обслуговування',
		'Контакти отримувача': 'Контакти отримувача',
		'Відділення/Адреса': 'Відділення/Адреса',
		'Адреса доставки': 'Адреса доставки',
		'Історія змін': 'Історія змін',
		'ID замовлення': 'ID замовлення',
		'Накладна': 'Накладна',
		'Система управління замовленнями': 'Система управління замовленнями',
		'cabinet.choice.ua': 'cabinet.choice.ua',
		'Контактна інформація': 'Контактна інформація',
		'Отримувач': 'Отримувач',
		'Телефон': 'Телефон',
		'Товари': 'Товари',
		'Фото': 'Фото',
		'Назва товару': 'Назва товару',
		'Кількість': 'Кількість',
		'Ціна': 'Ціна',
		'Сума': 'Сума',
		'Загальна сума': 'Загальна сума',
		'Документ згенеровано автоматично': 'Документ згенеровано автоматично',
		'Дата генерації': 'Дата генерації',
		'Завантаження...': 'Завантаження...',
		'Помилка завантаження даних': 'Помилка завантаження даних',
		'Помилка завантаження інформації про замовлення': 'Помилка завантаження інформації про замовлення',
		'Накладна №': 'Накладна №',
		'Перевірте вашу посилку, порахуйте всі товари та введіть в колонку "Отримано" кількість отриманого товару. Далі "Підтвердіть отримання" або "поверніть недостачу". Натискаючи на ці кнопки ви погоджуєтесь з тим що отримали ці товари і вони додадуться до балансу вашого складу.':
			'Перевірте вашу посилку, порахуйте всі товари та введіть в колонку "Отримано" кількість отриманого товару. Далі "Підтвердіть отримання" або "поверніть недостачу". Натискаючи на ці кнопки ви погоджуєтесь з тим що отримали ці товари і вони додадуться до балансу вашого складу.',
		'Відмітити всі': 'Відмітити всі',
		'Підтвердити та повернути недостачу': 'Підтвердити та повернути недостачу',
		'Ви дійсно підтверджуєте отримання всіх товарів?': 'Ви дійсно підтверджуєте отримання всіх товарів?',
		'Ви дійсно підтверджуєте отримання з поверненням недостачі?': 'Ви дійсно підтверджуєте отримання з поверненням недостачі?',
		'Немає товарів для підтвердження': 'Немає товарів для підтвердження',
		'Товари не оброблені': 'Товари не оброблені',
		'API Response:': 'API Response:',
		'Products from API:': 'Products from API:',
		Редагувати: 'Редагувати',
		Інфо: 'Інфо',
		Відгрузити: 'Відгрузити',
		'Підтвердити оплату': 'Підтвердити оплату',
		'Прийняти в обробку': 'Прийняти в обробку',
		Так: 'Так',
		Ні: 'Ні',
		'Підтвердження дії': 'Підтвердження дії',
		або: 'або',
		Успішно: 'Успішно',
		Помилка: 'Помилка',
		'Введіть будь ласка більше 3 символів':
			'Введіть будь ласка більше 3 символів',
		'Ви дійсно хочете прийняти замовлення в обробку?':
			'Ви дійсно хочете прийняти замовлення в обробку?',
		'Ви дійсно хочете підтвердити оплату замовлення?':
			'Ви дійсно хочете підтвердити оплату замовлення?',
		'Ви дійсно хочете відгрузити замовлення?':
			'Ви дійсно хочете відгрузити замовлення?',
		'Редагувати замовлення': 'Редагувати замовлення',
		'ще не отримано': 'ще не отримано',
		чернетка: 'чернетка',
		'Товарний звіт': 'Товарний звіт',
		'Залишок продукції на складі': 'Залишок продукції на складі',
		'Данні відсутні': 'Данні відсутні',
		'Таблиця товарів': 'Таблиця товарів',
		'Оберіть адресу доставки': 'Оберіть адресу доставки',
		'Додати нову адресу': 'Додати нову адресу',
		'Підтвердити товари': 'Підтвердити товари',
		'Підтвердити': 'Підтвердити',
		'Замовлення підтверджено': 'Замовлення підтверджено',
		'Щось пішло не так': 'Щось пішло не так',
		'Авторизація касира': 'Авторизація касира',
		Логін: 'Логін',
		Пароль: 'Пароль',
		Постачальник: 'Постачальник',
		'Обрати іншого постачальника': 'Обрати іншого постачальника',
		Обрати: 'Обрати',
		касир: 'касир',
		'Дата звіту': 'Дата звіту',
		дія: 'дія',
		Відкрити: 'Відкрити',
		Головна: 'Головна',
		'Список касових ордерів': 'Список касових ордерів',
		'дивитися більше': 'дивитися більше',
		'СПИСОК КАСОВИХ ОРДЕРІВ': 'СПИСОК КАСОВИХ ОРДЕРІВ',
		'Створити касовий ордер': 'Створити касовий ордер',
		Оплата: 'Оплата',
		'Сума оплати': 'Сума оплати',
		'По заданим параметрам оформлення відсутні': 'По заданим параметрам оформлення відсутні',
		'всього балів': 'всього балів',
		'всього грошей': 'всього грошей',
		'Історія зміни оформлень': 'Історія зміни оформлень',
		'По обраним оформленням зміни відсутні': 'По обраним оформленням зміни відсутні',
		'Інформація про замовлення': 'Інформація про замовлення',
		Інформація: 'Інформація',
		'Учасники': 'Учасники',
		'Товари та послуги': 'Товари та послуги',
		'Ціна за од.': 'Ціна за од.',
		'Бали за од.': 'Бали за од.',
		'Підсумки': 'Підсумки',
		'Розмір знижки': 'Розмір знижки',
		'Зміна пароля': 'Зміна пароля',
		'Введіть старий пароль': 'Введіть старий пароль',
		'Введіть новий пароль': 'Введіть новий пароль',
		'Старий пароль вірний': 'Старий пароль вірний',
		'Невірний старий пароль': 'Невірний старий пароль',
		'Спочатку підтвердіть старий пароль': 'Спочатку підтвердіть старий пароль',
		'Показати пароль': 'Показати пароль',
		'Сховати пароль': 'Сховати пароль',
		'Повернутися на головну': 'Повернутися на головну',
		'Спробувати ще раз': 'Спробувати ще раз',
		'От халепа!': 'От халепа!',
		'Деталі для підтримки': 'Деталі для підтримки',
		'Повідомлення': 'Повідомлення',
		'Сторінку не знайдено': 'Сторінку не знайдено',
		'Такої сторінки не існує або вона була переміщена. Перевірте коректність адреси або поверніться на головну.':
			'Такої сторінки не існує або вона була переміщена. Перевірте коректність адреси або поверніться на головну.',
		'Повернутися назад': 'Повернутися назад',
		Дата: 'Дата',
		Активован: 'Активован',
		Контракт: 'Контракт',
		"Ім'я": "Ім'я",
		Спонсор: 'Спонсор',
		Чоловік: 'Чоловік',
		Жінка: 'Жінка',
		"Тут з'явиться інформація коли ви зареєструєте клієнтів в свою мережу.":
			"Тут з'явиться інформація коли ви зареєструєте клієнтів в свою мережу.",
		Україна: 'Україна',
		клієнта: 'клієнта',
		партнера: 'партнера',
		Клієнт: 'Клієнт',
		Партнер: 'Партнер',
		'Тип новачка': 'Тип новачка',
		Країна: 'Країна',
		'Статуту компанії': 'Статуту компанії',
		'реєстрація клієнта': 'реєстрація клієнта',
		'реєстрація партнера': 'реєстрація партнера',
		'зареєструвати клієнта': 'зареєструвати клієнта',
		'зареєструвати партнера': 'зареєструвати партнера',
		Валюта: 'Валюта',
		'Номер контракту': 'Номер контракту',
		'Дата народження': 'Дата народження',
		МІСТО: 'МІСТО',
		КОНТАКТ: 'КОНТАКТ',
		'Особистий ТО': 'Особистий ТО',
		'Командний ТО': 'Командний ТО',
		'Дата Реєстрації': 'Дата Реєстрації',
		Кваліфікація: 'Кваліфікація',
		'Клієнтів в дереві': 'Клієнтів в дереві',
		редагувати: 'редагувати',
		Закрити: 'Закрити',
		'Застосувати': 'Застосувати',
		Очистити: 'Очистити',
		Харків: 'Харків',
		'Дивитися більше': 'Дивитися більше',
		'Дивитись більше': 'Дивитись більше',
		'Конвертація ': 'Конвертація ',
		'Отримання коштів': 'Отримання коштів',
		'Переведено до мене': 'Переведено до мене',
		'Переведено від мене': 'Переведено від мене',
		закрити: 'закрити',
		'додати фільтр': 'додати фільтр',
		'Підтвердження залишків продукції на складі':
			'Підтвердження залишків продукції на складі',
		'Оберіть місяць': 'Оберіть місяць',
		Січень: 'Січень',
		Лютий: 'Лютий',
		Березень: 'Березень',
		Квітень: 'Квітень',
		Травень: 'Травень',
		Червень: 'Червень',
		Липень: 'Липень',
		Серпень: 'Серпень',
		Вересень: 'Вересень',
		Жовтень: 'Жовтень',
		Листопад: 'Листопад',
		Грудень: 'Грудень',
		'На початок': 'На початок',
		Прихід: 'Прихід',
		Повернення: 'Повернення',
		Оформлення: 'Оформлення',
		'На кінець': 'На кінець',
		Далі: 'Далі',
		Баланс: 'Баланс',
		'Таблиця руху товару': 'Таблиця руху товару',
		'Вид дії': 'Вид дії',
		'Різниця сумарного по дням командного обсягу між поточним місяцем та цього самого дня минулого місяця':
			'Різниця сумарного по дням командного обсягу між поточним місяцем та цього самого дня минулого місяця',
		'з {{from}} до {{to}}': 'з {{from}} до {{to}}',
		Рівень: 'Рівень',
		Всього: 'Всього',
		'Лідери команди': 'Лідери команди',
		'ЛИЧНОГО ОБЬЕМА': 'ЛИЧНОГО ОБЬЕМА',
		'Команда (новачки)': 'Команда (новачки)',
		видалено: 'видалено',
		зареєстровано: 'зареєстровано',
		'Мережа клієнтів': 'Мережа клієнтів',
		'Розподіл кваліфікацій за рівнями': 'Розподіл кваліфікацій за рівнями',
		лiнiя: 'лiнiя',
		'Історія маркетингплану': 'Історія маркетингплану',
		'Історія кваліфікацій': 'Історія кваліфікацій',
		'Особистий профіль': 'Особистий профіль',
		'Основна інформація': 'Основна інформація',
		Прізвище: 'Прізвище',
		'По батькові': 'По батькові',
		Стать: 'Стать',
		Чоловіча: 'Чоловіча',
		Жіноча: 'Жіноча',
		'Електронна пошта': 'Електронна пошта',
		Область: 'Область',
		Місто: 'Місто',
		Адреса: 'Адреса',
		'Посилання на соціальні мережі': 'Посилання на соціальні мережі',
		'Введіть посилання': 'Введіть посилання',
		'Телефон для контактів': 'Телефон для контактів',
		'ЗБЕРЕГТИ ЗМІНИ': 'ЗБЕРЕГТИ ЗМІНИ',
		Разом: 'Разом',
		'Сум 5': 'Сум 5',
		'Сум 6': 'Сум 6',
		'Сум 7': 'Сум 7',
		'Середній показник за день': 'Середній показник за день',
		'Вхід у кабінет': 'Вхід у кабінет',
		Вихід: 'Вихід',
		'Мій бізнес': 'Мій бізнес',
		'Мій партнерський дохід': 'Мій партнерський дохід',
		'Мої замовлення': 'Мої замовлення',
		'Мої замовлення Менеджер': 'Мої замовлення Менеджер',
		'Моя динаміка': 'Моя динаміка',
		Склад: 'Склад',
		'До сайту': 'До сайту',
		Магазин: 'Магазин',
		'Про компанію': 'Про компанію',
		Виробники: 'Виробники',
		Контакти: 'Контакти',
		Каталог: 'Каталог',
		Мова: 'Мова',
		'Список накладних': 'Список накладних',
		'Список товарів': 'Список товарів',
		'Список оформлень': 'Список оформлень',
		'Список бонусів': 'Список бонусів',
		'Фінансовий звіт': 'Фінансовий звіт',
		Новини: 'Новини',
		Навчання: 'Навчання',
		Медіабаза: 'Медіабаза',
		'Академія розвитку': 'Академія розвитку',
		'Оберіть місяць ': 'Оберіть місяць ',
		Бонусів: 'Бонусів',
		бонусів: 'бонусів',
		'Бонуси за цей місяць відсутні': 'Бонуси за цей місяць відсутні',
		Замовлення: 'Замовлення',
		'Введіть текст для пошуку...': 'Введіть текст для пошуку...',
		'Перемістити в дереві': 'Перемістити в дереві',
		'Оформити бали': 'Оформити бали',
		'Підтвердження номера': 'Підтвердження номера',
		'Підтвердіть зміну номера': 'Підтвердіть зміну номера',
		'ОТРИМАТИ смс': 'ОТРИМАТИ смс',
		'СКАСУВАТИ НОМЕР': 'СКАСУВАТИ НОМЕР',
		'Код СМС': 'Код СМС',
		Відправити: 'Відправити',
		'Мій бонусний рахунок': 'Мій бонусний рахунок',
		'В цьому місяці вам нараховано премію': 'В цьому місяці вам нараховано премію',
		'За виконання умов бонусної програми та': 'За виконання умов бонусної програми та',
		'умов отримання премій': 'умов отримання премій',
		'До наступної премії тобі залишилось сумарно': 'До наступної премії тобі залишилось сумарно',
		Балів: 'Балів',
		'в двох гілках': 'в двох гілках',
		'розмір наступної премії': 'розмір наступної премії',
		'Мої рахунки': 'Мої рахунки',
		'Переглянути транзакції': 'Переглянути транзакції',
		'Виведення винагороди': 'Виведення винагороди',
		Переказ: 'Переказ',
		Конвертація: 'Конвертація',
		'Введіть число': 'Введіть число',
		'Недостатньо коштів': 'Недостатньо коштів',
		Міняю: 'Міняю',
		Отримую: 'Отримую',
		Доступно: 'Доступно',
		грн: 'грн',
		'Мій рахунок': 'Мій рахунок',
		'Рахунок отримувача': 'Рахунок отримувача',
		'Вибір валюти': 'Вибір валюти',
		'Введіть бажану суму': 'Введіть бажану суму',
		'Доступно для переказу': 'Доступно для переказу',
		'Виберіть рахунок': 'Виберіть рахунок',
		'Партнери у кваліфікації': 'Партнери у кваліфікації',
		'До наступної кваліфікації вам потрібно': 'До наступної кваліфікації вам потрібно',
		'Найближча кваліфікація': 'Найближча кваліфікація',
		Дивитися: 'Дивитися',
		'Мої реферальні посилання': 'Мої реферальні посилання',
		'Поточна кваліфікація': 'Поточна кваліфікація',
		назад: 'назад',
		підтверджено: 'підтверджено',
		відхилено: 'відхилено',
		сплачено: 'сплачено',
		відкладене: 'відкладене',
		звичайне: 'звичайне',
		Назва: 'Назва',
		'Всього вартість': 'Всього вартість',
		'Всього бали': 'Всього бали',
		'Загальна кількість балів': 'Загальна кількість балів',
		'Загальна вартість замовлення': 'Загальна вартість замовлення',
		'Розмір кешбека': 'Розмір кешбека',
		'з них оплачено бонусами': 'з них оплачено бонусами',
		'Ваш обраний товар': 'Ваш обраний товар',
		'Загальна вага': 'Загальна вага',
		'Немає результатів': 'Немає результатів',
		'Клієнт з таким номером контрактом вже втратив контракт':
			'Клієнт з таким номером контрактом вже втратив контракт',
		'Клієнт в дереві': 'Клієнт в дереві',
		'Контракт не в вашій структурі': 'Контракт не в вашій структурі',
		'Клієнт не активний': 'Клієнт не активний',
		'Клієнт активний на': 'Клієнт активний на',
		'Контракт партнера': 'Контракт партнера',
		'Мої клієнти': 'Мої клієнти',
		'Зареєструвати заново': 'Зареєструвати заново',
		'На бонусному рахунку клієнта': 'На бонусному рахунку клієнта',
		'Введіть номер контракту': 'Введіть номер контракту',
		"Дерево дистриб'юторів": "Дерево дистриб'юторів",
		'Вибір клієнта': 'Вибір клієнта',
		Чернетка: 'Чернетка',
		'Оберіть місто': 'Оберіть місто',
		Відділення: 'Відділення',
		Поштомат: 'Поштомат',
		'Оберіть область': 'Оберіть область',
		'Дохід від побудови власної мережі': 'Дохід від побудови власної мережі',
		'Нараховано цього місяця': 'Нараховано цього місяця',
		'Дохід CashBack': 'Дохід CashBack',
		'Архів Cashback': 'Архів Cashback',
		'Дохід за програмою Optima': 'Дохід за програмою Optima',
		'ВСІ OPTIMA': 'ВСІ OPTIMA',
		'Сторінка недоступна': 'Сторінка недоступна',
		'І він складається з:\n1) Дохід від побудови власної мережі\n2) Дохід CashBack \n3) Дохід за програмою OPTIMA\n':
			'І він складається з:\n1) Дохід від побудови власної мережі\n2) Дохід CashBack \n3) Дохід за програмою OPTIMA\n',
		'Мій партнерський дохід — це загальна сума всіх винагород, які ви отримуєте від співпраці з компанією CHOICE:\n':
			'Мій партнерський дохід — це загальна сума всіх винагород, які ви отримуєте від співпраці з компанією CHOICE:\n',
		'«Натискаючи «Зареєструвати», Ви підтверджуєте, що ознайомлені з положеннями та умовами»':
			'«Натискаючи «Зареєструвати», Ви підтверджуєте, що ознайомлені з положеннями та умовами»',
		'Покупець': 'Покупець',
		'Ви авторизовані як': 'Ви авторизовані як',
		'номер лояльності': 'номер лояльності',
		'За цей місяць у Вас вже зараховано': 'За цей місяць у Вас вже зараховано',
		Б: 'Б',
		'про свою активність Ви можете переглянути на сторінці': 'про свою активність Ви можете переглянути на сторінці',
		кабінету: 'кабінету',
		'Якщо Ви хочете надалі оформити ці бали на своїх партнерів, то поставте нижче позначку':
			'Якщо Ви хочете надалі оформити ці бали на своїх партнерів, то поставте нижче позначку',
		'зробити відкладеним оформленням': 'зробити відкладеним оформленням',
		'Виберіть контакт зі списку': 'Виберіть контакт зі списку',
		'Коментар до замовлення': 'Коментар до замовлення',
		'Введіть текст': 'Введіть текст',
		'Я прочитав/прочитала і прийняв/прийняла повідомлення і текст згоди з Умовами та Політикою захисту даних':
			'Я прочитав/прочитала і прийняв/прийняла повідомлення і текст згоди з Умовами та Політикою захисту даних',
		'Оформити замовлення': 'Оформити замовлення',
		'Відхилити': 'Відхилити',
		'Підтвердження отримання коштів': 'Підтвердження отримання коштів',
		'Введіть новий контакт': 'Введіть новий контакт',
		Город: 'Город',
		Отделение: 'Отделение',
		'Выберите имя получателя': 'Выберите имя получателя',
		'Выберите способ оплаты': 'Выберите способ оплаты',
		'Реєстрація партнера/клієнта': 'Реєстрація партнера/клієнта',
		'byCHOICE.BOT': 'byCHOICE.BOT',
		'За вказаний період дані відсутні': 'За вказаний період дані відсутні',
	},
};
